<template>
  <div id="vue-app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>
